import React from "react"

import { TeamsOverviewPage } from "./TeamsOverviewPage"
import { useTeamsOverviewPageModel } from "./hooks/useTeamsOverviewPageModel"

export const TeamsOverviewPageConnector = React.memo(() => {
  return <TeamsOverviewPage {...useTeamsOverviewPageModel()} />
})
